<template>
  <panel :title="$t('integration.label')">
    <loader :loading="loading"/>

    <div class="btnGroup" slot="header-right">
      <button @click="level = null" v-bind:class="{ 'is-active': !level }" class="btn btn--sm btn--info btn--outline">
        Todos
      </button>
      <button @click="level = 'critical'" v-bind:class="{ 'is-active': level }" class="btn btn--sm btn--danger btn--outline">
        Erros
      </button>
    </div>

    <ul class="c-stream" v-if="logsTotal > 0">
      <li class="c-stream__item " v-for="log in logs" :key="log">
        <span class="c-stream__badge hint" :class="log.level" :data-label="$t(`level.${log.level}.label`)"></span>
        <time class="u-text-muted u-fs-12">{{ log.updated | moment('from') }}</time>
        <div @click="showModal(log)" class="link">
          {{ log.message }}
        </div>
      </li>
    </ul>

    <div class="u-textCenter" v-else>
      Nenhum registro encontrado.
    </div>

    <log-modal v-model="showModalFlag" :log="modalLog" v-if="modalLog"/>
  </panel>
</template>

<script>
  import { merge } from 'lodash'
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import LogModal from '@/components/shared/LogModal'

  export default {
    data: () => ({
      loading: false,
      showModalFlag: false,
      modalLog: null,
      level: null
    }),
    props: {
      options: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      this.onChange({})
    },
    methods: {
      ...mapActions('logs', [
        'fetch'
      ]),
      showModal (log) {
        this.modalLog = log
        this.showModalFlag = true
      },
      async onChange (options) {
        this.loading = true

        merge(options, this.options)

        await this.fetch({
          options: options
        })

        this.loading = false
      }
    },
    computed: {
      ...mapFields({
        logsTotal: 'logs.total',
        logs: 'logs.logs'
      })
    },
    watch: {
      level () {
        this.onChange({ level: this.level })
      }
    },
    components: {
      Panel,
      Loader,
      LogModal
    }
  }
</script>



// WEBPACK FOOTER //
// SimpleListLog.vue?58d46328